import axios from 'axios';
import cfac22 from '../../cfac22';
import { getFingerprint } from '../../getFingerprint';

export const refreshToken = async () => {
  try {
    const endpoint = `${cfac22('MICROSERVICES')}/auth/refresh`;

    const fingerprint = await getFingerprint();

    const { data } = await axios.post(
      endpoint,
      {
        clientType: 'web',
        fingerprint,
      },
      {
        withCredentials: true,
        headers: {
          'Full-Url': window.location.href,
        },
      }
    );

    const { status, success, result, error, message } = data;

    if (status !== 'success' && status !== true && success !== true) {
      return {
        success: false,
        error: error || message || 'Erro ao realizar refresh do token',
      };
    }

    const { accessToken, message: resultMessage } = result || {};
    const hasAccessToken =
      typeof accessToken === 'string' ? Boolean(accessToken) : Boolean(accessToken?.token);

    if (!hasAccessToken) {
      return {
        success: false,
        error: resultMessage || message || error || 'Refresh não retornou um accessToken',
      };
    }

    return {
      success: true,
      data: {
        accessToken,
        message: resultMessage,
      },
    };
  } catch (error) {
    throw error?.response?.data || error;
  }
};
